import axios from "axios"
import { del, get, post, postMultipart, put } from "./api_helper"
import * as url from "./url_helper"

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user")
  if (user) return JSON.parse(user)
  return null
}

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// Register Method
const postFakeRegister = data => post(url.POST_FAKE_REGISTER, data)

// Login Method
const postFakeLogin = data => post("/users/login", data)

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data)

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data)

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data)

// Register Method
const postJwtRegister = (url, data) => {
  return axios
    .post(url, data)
    .then(response => {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    })
    .catch(err => {
      var message
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found"
            break
          case 500:
            message =
              "Sorry! something went wrong, please contact our support team"
            break
          case 401:
            message = "Invalid credentials"
            break
          default:
            message = err[1]
            break
        }
      }
      throw message
    })
}

// Login Method
const postJwtLogin = data => post("/auth-admins/login", data)
export const resetPasswordApi = data => post("/auth/reset_password", data)

// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data)

// postSocialLogin
export const postSocialLogin = data => post(url.SOCIAL_LOGIN, data)

// get Products
export const getProducts = () => get(url.GET_PRODUCTS)

// get Product detail
export const getProductDetail = id =>
  get(`${url.GET_PRODUCTS_DETAIL}/${id}`, { params: { id } })

// // get Events
// export const getEvents = () => get(url.GET_EVENTS);

// // add Events
// export const addNewEvent = (event) => post(url.ADD_NEW_EVENT, event);

// // update Event
// export const updateEvent = (event) => put(url.UPDATE_EVENT, event);

// // delete Event
// export const deleteEvent = (event) =>
//   del(url.DELETE_EVENT, { headers: { event } });

// get Categories
export const getCategories = () => get(url.GET_CATEGORIES)

// get chats
export const getChats = () => get(url.GET_CHATS)

// get groups
export const getGroups = () => get(url.GET_GROUPS)

// get Contacts
export const getContacts = () => get(url.GET_CONTACTS)

// get messages
export const getMessages = (roomId = "") =>
  get(`${url.GET_MESSAGES}/${roomId}`, { params: { roomId } })

// post messages
export const addMessage = message => post(url.ADD_MESSAGE, message)

// get orders
export const getOrders = () => get(url.GET_ORDERS)

// add order
export const addNewOrder = order => post(url.ADD_NEW_ORDER, order)

// update order
export const updateOrder = order => put(url.UPDATE_ORDER, order)

// delete order
export const deleteOrder = order =>
  del(url.DELETE_ORDER, { headers: { order } })

// get cart data
export const getCartData = () => get(url.GET_CART_DATA)

// get customers
export const getCustomers = () => get(url.GET_CUSTOMERS)

// add CUSTOMER
export const addNewCustomer = customer => post(url.ADD_NEW_CUSTOMER, customer)

// update CUSTOMER
export const updateCustomer = customer => put(url.UPDATE_CUSTOMER, customer)

// delete CUSTOMER
export const deleteCustomer = customer =>
  del(url.DELETE_CUSTOMER, { headers: { customer } })

// get shops
export const getShops = () => get(url.GET_SHOPS)

// get wallet
export const getWallet = () => get(url.GET_WALLET)

// get crypto order
export const getCryptoOrder = () => get(url.GET_CRYPTO_ORDERS)

// get invoices
export const getInvoices = () => get(url.GET_INVOICES)

// add invoices
export const addNewInvoice = invoice => post(url.ADD_NEW_INVOICE, invoice)

//update invoices
export const updateInvoice = invoice => put(url.UPDATE_INVOICE, invoice)

//delete invoice
export const deleteInvoice = invoice =>
  del(url.DELETE_INVOICE, { headers: { invoice } })

// get invoice details
export const getInvoiceDetail = id =>
  get(`${url.GET_INVOICE_DETAIL}/${id}`, { params: { id } })

// get project
export const getProjects = () => get(url.GET_PROJECTS)

// get project details
export const getProjectsDetails = id =>
  get(`${url.GET_PROJECT_DETAIL}/${id}`, { params: { id } })

// get tasks
export const getTasks = () => get(url.GET_TASKS)

// contacts
export const getUsers = () => get(url.GET_USERS)
export const addNewUser = user => post(url.ADD_NEW_USER, user)
export const updateUser = user => put(url.UPDATE_USER, user)
export const deleteUser = user => del(url.DELETE_USER, { headers: { user } })

// admins
export const getAdmins = payload =>
  get(
    url.GET_ADMINS +
      "?offset=" +
      payload.offset +
      "&page_size=" +
      payload.page_size
  )
export const addNewAdmin = user => postMultipart(url.ADD_NEW_ADMIN, user)
export const updateAdmin = user =>
  postMultipart(`${url.UPDATE_ADMIN}/${user.id}`, user)
export const deleteAdmin = user => get(`${url.DELETE_ADMIN}/${user.id}`)

// admins
export const getPurchases = ({ offset, page_size }) =>
  get(url.GET_PURCHASES + "/" + `?offset=${offset}&page_size=${page_size}`)
export const addNewPurchase = user => postMultipart(url.ADD_NEW_PURCHASE, user)
export const updatePurchase = user => post(`${url.UPDATE_PURCHASE}`, user)
export const deletePurchase = user => get(`${url.DELETE_PURCHASE}/${user.id}`)

export const getReviews = ({ date, query, offset, page_size }) =>
  get(
    url.GET_REVIEWS +
      "/" +
      `?offset=${offset}&page_size=${page_size}&query=${query}&date=${date}`
  )
export const addNewReview = user => postMultipart(url.ADD_NEW_REVIEW, user)
export const updateReview = user =>
  post(`${url.UPDATE_REVIEW}/${user.id}`, user)
export const deleteReview = user => get(`${url.DELETE_REVIEW}/${user.id}`)
// settings
export const getSettings = client_id => get(url.GET_SETTINGS)
export const updateSetting = setting =>
  postMultipart(`${url.UPDATE_SETTING}/${setting.id}`, setting)

// ceremony
export const getCeremonies = data =>
  get(
    url.GET_CEREMONIES +
      "/" +
      data.is_active +
      "/?offset=" +
      data.offset +
      "&page_size=" +
      data.page_size
  )
export const addNewCeremony = user => postMultipart(url.ADD_NEW_CEREMONY, user)
export const updateCeremony = user =>
  postMultipart(`${url.UPDATE_CEREMONY}/${user.id}`, user)
export const deleteCeremony = user => get(`${url.DELETE_CEREMONY}/${user.id}`)

export const getCeremonies_pack = payload =>
  get(
    `${url.GET_CEREMONIES_PACK}?offset=${payload.offset}&page_size=${payload.page_size}`
  )
export const addNewCeremony_pack = user => post(url.ADD_NEW_CEREMONY_PACK, user)
export const updateCeremony_pack = user =>
  post(`${url.UPDATE_CEREMONY_PACK}/${user.id}`, user)
export const deleteCeremony_pack = user =>
  get(`${url.DELETE_CEREMONY_PACK}/${user.id}`)

//budget percentage
export const getBudgets_percentage = payload =>
  get(
    `${url.GET_BUDGETS_PERCENTAGE}?offset=${payload.offset}&page_size=${payload.page_size}`
  )
export const addNewBudget_percentage = user =>
  post(url.ADD_NEW_BUDGET_PERCENTAGE, user)
export const updateBudget_percentage = user =>
  post(`${url.UPDATE_BUDGET_PERCENTAGE}/${user.id}`, user)
export const deleteBudget_percentage = user =>
  get(`${url.DELETE_BUDGET_PERCENTAGE}/${user.id}`)

// vendor
export const getVendor_cats = ({ is_active, offset, page_size }) =>
  get(
    url.GET_VENDOR_CATS +
      "/" +
      is_active +
      `?offset=${offset}&page_size=${page_size}`
  )
export const getVendor_catsByvendorId = ({ vendor_id, offset, page_size }) =>
  get(
    url.GET_VENDOR_CATS +
      "/by-vendor/" +
      vendor_id +
      `?offset=${offset}&page_size=${page_size}`
  )
export const addNewVendor_cat = user =>
  postMultipart(url.ADD_NEW_VENDOR_CAT, user)
export const updateVendor_cat = user =>
  postMultipart(`${url.UPDATE_VENDOR_CAT}/${user.id}`, user)
export const deleteVendor_cat = user =>
  get(`${url.DELETE_VENDOR_CAT}/${user.id}`)

//unit of measure
export const getUnitOfMeasure = () => get(url.GTE_UNIT_OF_MEASURE)

//file manager
export const getFolders = ({ id }) => get(url.GET_FOLDERS + "/" + id)
export const deleteFolder = ({ id }) => get(url.DELETE_FOLDER + "/" + id)
export const renameFolder = data => post(url.RENAME_FOLDER, data)
export const addFolder = data => post(url.ADD_FOLDER, data)

export const getFiles = ({ id }) => get(url.GET_FILES_BY_FOLDER + "/" + id)
export const uploadFilesToFolder = data => postMultipart(url.ADD_FILE, data)
export const deleteFile = ({ id }) => get(url.DELETE_FILE + "/" + id)

export const getType_Services = ({
  vendor_type_id,
  is_active,
  offset,
  page_size,
}) =>
  get(
    url.GET_TYPE_SERVICES +
      "/" +
      vendor_type_id +
      "/" +
      is_active +
      `?offset=${offset}&page_size=${page_size}`
  )
export const addNewType_Service = data => post(url.ADD_NEW_TYPE_SERVICE, data)
export const updateType_Service = data =>
  post(`${url.UPDATE_TYPE_SERVICE}/${data.id}`, data)
export const deleteType_Service = data =>
  get(`${url.DELETE_TYPE_SERVICE}/${data.id}`)

export const getType_Settings = ({
  vendor_type_id,
  is_active,
  offset,
  page_size,
}) =>
  get(
    url.GET_TYPE_SETTINGS +
      "/" +
      vendor_type_id +
      "/" +
      is_active +
      `?offset=${offset}&page_size=${page_size}`
  )
export const addNewType_Setting = data => post(url.ADD_NEW_TYPE_SETTING, data)
export const updateType_Setting = data =>
  post(`${url.UPDATE_TYPE_SETTING}/${data.id}`, data)
export const deleteType_Setting = data =>
  get(`${url.DELETE_TYPE_SETTING}/${data.id}`)

export const getVendors = payload => {
  console.log(
    url.GET_VENDORS +
      `?offset=${payload.offset}&page_size=${payload.page_size}&query=${payload.query}&status_vendor=${payload?.status}`
  )
  return get(
    url.GET_VENDORS +
      `?offset=${payload.offset}&page_size=${payload.page_size}&query=${payload.query}&status_vendor=${payload?.status}`
  )
}
export const getVendorProfile = id => get(url.GET_VENDORS + "/" + id)
export const addNewVendor = user => postMultipart(url.ADD_NEW_VENDOR, user)
export const updateVendor = user =>
  postMultipart(`${url.UPDATE_VENDOR}/${user.id}`, user)
export const deleteVendor = user => get(`${url.DELETE_VENDOR}/${user.id}`)

export const getVendor_media = ({ id, offset, page_size }) =>
  get(
    url.GET_VENDOR_MEDIA + "/" + id + `?offset=${offset}&page_size=${page_size}`
  )
export const addNewVendor_media = user =>
  postMultipart(url.ADD_NEW_VENDOR_MEDIA, user)
export const updateVendor_media = user =>
  postMultipart(`${url.UPDATE_VENDOR_MEDIA}/${user.id}`, user)
export const deleteVendor_media = user =>
  get(`${url.DELETE_VENDOR_MEDIA}/${user.id}`)

export const getVendor_pricing = ({ id, offset, page_size }) =>
  get(
    url.GET_VENDOR_PRICING +
      "/" +
      id +
      `?offset=${offset}&page_size=${page_size}`
  )
export const addNewVendor_pricing = user =>
  postMultipart(url.ADD_NEW_VENDOR_PRICING, user)
export const updateVendor_pricing = user =>
  postMultipart(`${url.UPDATE_VENDOR_PRICING}/${user.id}`, user)
export const deleteVendor_pricing = user =>
  get(`${url.DELETE_VENDOR_PRICING}/${user.id}`)

export const getVendor_event = ({ id, offset, page_size }) =>
  get(
    url.GET_VENDOR_EVENT + "/" + id + `?offset=${offset}&page_size=${page_size}`
  )
export const addNewVendor_event = user =>
  postMultipart(url.ADD_NEW_VENDOR_EVENT, user)
export const updateVendor_event = user =>
  postMultipart(`${url.UPDATE_VENDOR_EVENT}/${user.id}`, user)
export const deleteVendor_event = user =>
  get(`${url.DELETE_VENDOR_EVENT}/${user.id}`)

// how it works
export const getHowitworks = data =>
  get(
    url.GET_HOWITWORKS +
      "/" +
      data.is_active +
      "/2/?offset=" +
      data.offset +
      "&page_size=" +
      data.page_size
  )
export const addNewHowitwork = user =>
  postMultipart(url.ADD_NEW_HOWITWORKS, user)
export const updateHowitwork = user =>
  postMultipart(`${url.UPDATE_HOWITWORKS}/${user.id}`, user)
export const deleteHowitwork = user =>
  get(`${url.DELETE_HOWITWORKS}/${user.id}`)

export const getFaqs = data =>
  get(
    url.GET_FAQS +
      "/" +
      data.is_active +
      "/?offset=" +
      data.offset +
      "&page_size=" +
      data.page_size
  )
export const addNewFaq = user => post(url.ADD_NEW_FAQS, user)
export const updateFaq = user => post(`${url.UPDATE_FAQS}/${user.id}`, user)
export const deleteFaq = user => get(`${url.DELETE_FAQS}/${user.id}`)
//clients
export const getClients = payload =>
  get(
    url.GET_CLIENTS +
      `?offset=${payload.offset}&page_size=${payload.page_size}&query=${payload.query}`
  )
export const addNewClient = user => postMultipart(url.ADD_NEW_CLIENT, user)
export const addNewPartner = user => post(url.ADD_NEW_PARTNER, user)
export const updateClient = user =>
  postMultipart(`${url.UPDATE_CLIENT}/${user.id}`, user)
export const deleteClient = user => get(`${url.DELETE_CLIENT}/${user.id}`)

//events getEvents_By_Id_1
export const getEvents_By_Id_1 = ({
  is_active,
  client_id,
  offset,
  page_size,
}) =>
  get(
    url.GET_EVENTS_1 +
      `/${client_id}/${is_active}?offset=${offset}&page_size=${page_size}`
  )
export const getEvents_1 = ({ is_active, offset, page_size }) =>
  get(
    url.GET_EVENTS_1 + `/${is_active}?offset=${offset}&page_size=${page_size}`
  )
export const addNewEvent_1 = user => postMultipart(url.ADD_NEW_EVENT_1, user)
export const updateEvent_1 = user =>
  postMultipart(`${url.UPDATE_EVENT_1}/${user.id}`, user)
export const deleteEvent_1 = user => del(`${url.DELETE_EVENT_1}/${user.id}`)

// address
export const getCountries = () => get(url.GTE_COUNTRIES)
export const getCities = () => get(url.GET_CITIES)
export const getCitiesByCountry = id => get(`${url.GET_CITIES_BY_COUNTRY}${id}`)

/** PROJECT */
// add user
export const addNewProject = project => post(url.ADD_NEW_PROJECT, project)
//send broadcast
export const sendBrodcast = project => post("/common/send", project)

// update user
export const updateProject = project => put(url.UPDATE_PROJECT, project)

// delete user
export const deleteProject = project =>
  del(url.DELETE_PROJECT, { headers: { project } })

export const getUserProfile = () => get(url.GET_USER_PROFILE)

export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postJwtRegister,
  postJwtLogin,
  postJwtForgetPwd,
  postJwtProfile,
}
